const processData = (item) => {
  const { uuid, text, media_file, thumb_file, public_data } = item;
  const { childAge, childName, displayName } = public_data || {};

  return {
    id: uuid,
    title: text,
    name: displayName && childName !== '' ? childName : 'Stan & Gran Fan',
    age: childAge,
    description: '',
    imageUrl: thumb_file,
    link: false,
    type: 'gallery',
    mediaFile: media_file,
    publicData: public_data,
  };
};

export const parseData = (data = []) => {
  const entryIds = [];
  const entryById = {};

  if (data) {
    data.map((item, index) => {
      const { uuid } = item;

      entryIds.push(uuid);
      entryById[uuid] = processData(item);
    });
  }

  return { entryById, entryIds };
};
